import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionResetClientStore } from '../types';

const resetClientOptions: IActionResetClientStore = action(state => {
  state.clientOptionsByTeam = initStore.clientOptionsByTeam;
});

export default resetClientOptions;
